/**
 * Every table that owns a column set, mirroring the backend's
 * `DynamicTableNames`.
 *
 * A column belongs to exactly one table, which is why the vehicle module owns
 * three of them: its documents, expiration dates and services are separate
 * lists that share column names.
 */
export enum DynamicTable {
  ACTIVITIES = 'Activities',
  ISSUES = 'Issues',
  SALARY_APPROVE = 'SalaryApprove',
  VEHICLE_DOCUMENTS = 'VehicleDocuments',
  VEHICLE_EXPIRATIONS = 'VehicleExpirations',
  VEHICLE_SERVICES = 'VehicleServices',
}

export enum DynamicColumnType {
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  DATETIME_LOCATION = 'DATETIME_LOCATION',
  PLATE_NUMBER = 'PLATE_NUMBER',
  STRING = 'STRING',
  TIME = 'TIME',
  CHECKMARK = 'CHECKMARK',
  STATUS = 'STATUS',
  TYPE = 'TYPE',
}
